import { render, staticRenderFns } from "./ProjectLeader.vue?vue&type=template&id=2ba0257d&scoped=true"
import script from "./ProjectLeader.vue?vue&type=script&lang=js"
export * from "./ProjectLeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba0257d",
  null
  
)

export default component.exports